import React, { useEffect, useState } from "react";
import { Stepper } from "@mantine/core";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ecombo from "../../../../imgs/Logo_Ecombo 1.png";
import link from "../../../../imgs/link.png";
import linked from "../../../../imgs/linked.jpg";
import Loader from "../../../loader/Loader";
import AxiosController from "../../../authentication/AxiosController";
import { notifyError, notifySuccess } from "../../../toastify/toastify";

const Shopify = () => {
  const { slug, lang } = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  const [_] = useTranslation("global");
  const token = localStorage.getItem("token");

  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [shopDomain, setShopDomain] = useState("");
  const [integrations, setIntegrations] = useState([]);
  const [connecting, setConnecting] = useState(false);

  const fetchIntegrations = () => {
    setLoading(true);
    AxiosController.get(`api/${slug}/${lang}/shopify/integrations`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        setIntegrations(res.data.integrations || []);
        const hasActive = (res.data.integrations || []).some(
          (i) => i.status === "active"
        );
        if (hasActive) {
          setActive(2);
        } else if (urlParams.get("step")) {
          setActive(parseInt(urlParams.get("step")) - 1);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleConnect = () => {
    if (!shopDomain.trim()) {
      notifyError(_("panel.shopifyEnterDomain"));
      return;
    }

    setConnecting(true);
    AxiosController.post(
      `api/${slug}/${lang}/shopify/oauth/initiate`,
      { shop_domain: shopDomain.trim() },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        if (res.data.auth_url) {
          window.location.href = res.data.auth_url;
        }
        setConnecting(false);
      })
      .catch((e) => {
        notifyError(
          e?.response?.data?.message || _("panel.shopifySendError")
        );
        setConnecting(false);
      });
  };

  useEffect(() => {
    fetchIntegrations();
    // If returning from OAuth callback
    if (urlParams.get("shopify_connected") === "true") {
      setActive(2);
      notifySuccess(_("panel.shopifyConnected"));
    }
  }, []);

  return (
    <div className="w-100 pt-3 position-relative">
      <Loader active={loading} />
      <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 256 292"
        >
          <path
            fill="#95BF47"
            d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.183.053-3.388 1.046-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.98 0 119.468 0 75.733 0 54.893 54.674 48.277 82.474c-17.244 5.346-29.448 9.129-30.958 9.611-9.653 3.027-9.953 3.327-11.217 12.23C5.035 111.463 0 249.905 0 249.905l176.203 32.47 95.275-24.479S224.072 59.251 223.774 57.34"
          />
          <path
            fill="#5E8E3E"
            d="M185.645 53.24c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.95-2.394-1.069l-13.116 267.045 95.275-24.479S224.072 59.251 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
          />
          <path
            fill="#FFF"
            d="m135.587 104.027-11.045 32.851s-9.726-5.178-21.592-5.178c-17.451 0-18.327 10.95-18.327 13.726 0 15.075 39.287 20.843 39.287 56.158 0 27.789-17.613 45.681-41.396 45.681-28.514 0-43.1-17.739-43.1-17.739l7.636-25.22s14.994 12.886 27.66 12.886c8.282 0 11.697-6.522 11.697-11.292 0-19.705-32.237-20.583-32.237-52.882 0-27.206 19.535-53.528 58.979-53.528 15.19 0 22.438 4.537 22.438 4.537"
          />
        </svg>
        <img src={ecombo} width={"180px"} alt="Ecombo" />
      </div>
      <div>
        <Stepper active={active} onStepClick={setActive} color="#59C6C9">
          <Stepper.Step
            label={_("panel.First step")}
            description={_("panel.linkAccount")}
            disabled
          >
            <div className="d-flex flex-column align-items-center gap-3">
              <div>
                <p className="fs-5">
                  {_("panel.shopifyLinkDescription")}
                </p>
              </div>
              <div className="d-flex flex-column align-items-center gap-3 w-100" style={{ maxWidth: "500px" }}>
                <input
                  type="text"
                  className="form-control text-center"
                  placeholder={_("panel.shopifyEnterDomain")}
                  value={shopDomain}
                  onChange={(e) => setShopDomain(e.target.value)}
                  style={{ fontSize: "1.1rem", padding: "12px" }}
                />
                <button
                  className="btn w-100"
                  style={{
                    backgroundColor: "rgb(89, 198, 201)",
                    color: "white",
                    fontSize: "1.1rem",
                    padding: "12px",
                  }}
                  onClick={handleConnect}
                  disabled={connecting}
                >
                  {connecting
                    ? _("panel.shopifyConnecting")
                    : _("panel.connectShopify")}
                </button>
              </div>
              <img src={link} width={"100px"} alt="link" />
            </div>
          </Stepper.Step>

          <Stepper.Step
            label={_("panel.Second step")}
            description={_("panel.shopifyStatus")}
            disabled
          >
            <div className="d-flex flex-column align-items-center gap-3 py-4">
              <p className="fs-5">{_("panel.shopifyConnecting")}</p>
              <Loader active={true} />
            </div>
          </Stepper.Step>

          <Stepper.Step
            label={_("panel.Third step")}
            description={_("panel.shopifyConnected")}
            disabled
          >
            <div className="d-flex flex-column align-items-center gap-3 py-4">
              <img src={linked} width={"100px"} alt="linked" />
              <p className="fs-5 text-success">
                {_("panel.shopifyConnected")}
              </p>
              {integrations.length > 0 && (
                <div className="w-100" style={{ maxWidth: "600px" }}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>{_("panel.shopifyShopDomain")}</th>
                        <th>{_("panel.shopifyStatus")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {integrations
                        .filter((i) => i.status === "active")
                        .map((integration) => (
                          <tr key={integration.id}>
                            <td>{integration.shop_domain}</td>
                            <td>
                              <span
                                className="badge"
                                style={{
                                  backgroundColor: "rgb(1, 200, 92)",
                                  color: "white",
                                }}
                              >
                                {_("panel.shopifyActive")}
                              </span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              )}
              <button
                className="btn"
                style={{
                  backgroundColor: "rgb(89, 198, 201)",
                  color: "white",
                }}
                onClick={() => setActive(0)}
              >
                {_("panel.connectShopify")}
              </button>
            </div>
          </Stepper.Step>
        </Stepper>
      </div>
    </div>
  );
};

export default Shopify;
